import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import '@angular/compiler';
import {AppComponent} from './app.component';
import {JobboardComponent} from './jobboard/jobboard.component';
import {CrmComponent} from './crm/crm.component';
import {RouterModule, Routes} from '@angular/router';
import {JobboardModule} from './jobboard/jobboard.module';
// import {CrmModule} from "./crm/crm.module";
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AuthGuardService} from './jobboard/modules/auth/guards/auth-guard.service';
import {UserRoleGuardService} from './jobboard/modules/auth/guards/user-role-guard.service';
import {CrmModule} from './crm/crm.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

const appRoutes: Routes = [
    // { path: '', redirectTo: '/jobs', pathMatch: 'full' },
    // { path: 'jobs', component: JobboardComponent },
    // { path: 'crm', component: CrmComponent }
];

const cookieConfig: NgcCookieConsentConfig = {
    cookie: {
        domain: 'https://retail-jobs.ro/', // it is recommended to set your domain, for cookies to work properly
        expiryDays: 14,
        name: 'cookieconsent_status'
    },
    palette: {
        popup: {
            background: '#000'
        },
        button: {
            background: '#f1d600'
        }
    },
    theme: 'edgeless',
    type: 'opt-in',
    layout: 'my-custom-layout',
    layouts: {
        'my-custom-layout': '{{messagelink}}{{compliance}}'
    },
    elements: {
        messagelink: `
    <span id="cookieconsent:desc" class="cc-message">{{message}}
      <a aria-label="learn more about our privacy policy" tabindex="1" class="cc-link" href="{{privacyPolicyHref}}" target="_blank">{{privacyPolicyLink}}</a> și 
      <a aria-label="learn more about our terms of service" tabindex="2" class="cc-link" href="{{tosHref}}" target="_blank">{{tosLink}}</a>
    </span>
    `,
    },
    content: {
        message: 'Prin utilizarea site-ului nostru, recunoașteți că ați citit și înțeles ',

        allow: 'Accept Cookie-uri',
        deny: 'Refuz',

        privacyPolicyLink: 'Politica de confidențialitate',
        privacyPolicyHref: 'politica-confidentialitate',

        tosLink: 'Termenii și condițiile',
        tosHref: 'termeni-si-conditii',
    }
};


// ngx-translate
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        JobboardModule,
        CrmModule,
        RouterModule.forRoot(appRoutes, {scrollPositionRestoration: 'enabled'}),
        NgcCookieConsentModule.forRoot(cookieConfig),
        // ngx-translate
        NgbModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ServiceWorkerModule.register('./ngsw-worker.js', {
          enabled: environment.production,
          // Register the ServiceWorker as soon as the app is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [AuthGuardService, UserRoleGuardService],
    bootstrap: [AppComponent]
})
export class AppModule {
}


